import { GetterTree, Module } from 'vuex'
import { RootState } from '@/@next/store'

import { mutations } from './mutations'

import * as APP from '@/@next/store/app/types'

import { NetworkStatus } from '@/@next/@types'

export class AppState {
  network: NetworkStatus = {}
  modals: any[] = []
  isReady: boolean = false
  serviceWorkerIsReady: boolean = false
  // Preloader variables
  preloadDataset: any = null
  preloadStatus: string = 'off'
  displayPreloadStatus: boolean = false
  acceptPreload: boolean = false
  preloadSuccess: boolean = false
  preloadError: boolean = false
  needToReloadApp: boolean = false
}

const state: AppState = new AppState()

const getters: GetterTree<AppState, RootState> = {
  [APP.APP_IS_READY]: (state) => state.isReady,
  [APP.GET_NETWORK]: (state) => state.network,
  [APP.GET_MODALS]: (state) => state.modals,
  [APP.SERVICE_WORKER_IS_READY]: (state) => state.serviceWorkerIsReady,
  // Preloader Getters
  [APP.PRELOAD_DATASET]: (state) => state.preloadDataset,
  [APP.PRELOAD_STATUS]: (state) => state.preloadStatus,
  [APP.PRELOAD_ENDED]: (state) => state.preloadStatus === 'done',
  [APP.PRELOADING]: (state) => state.preloadStatus !== 'done' && state.preloadStatus !== 'off',
  [APP.DISPLAY_PRELOAD_STATUS]: (state) => state.displayPreloadStatus,
  [APP.ACCEPT_PRELOAD]: (state) => state.acceptPreload,
  [APP.PRELOAD_SUCCESS]: (state) => state.preloadSuccess,
  [APP.PRELOAD_ERROR]: (state) => state.preloadError,
  [APP.NEED_TO_RELOAD_APP]: (state) => state.needToReloadApp
}

export const app: Module<AppState, RootState> = {
  state,
  getters,
  mutations
}
